import axios from '../../utils/axios';

export const userApi = {
  createUser: (userData) => {
    return axios.post('/admin/create-user', userData);
  },
  getUsers: (page, limit) => {
    return axios.get(`/admin/users?limit=${limit}&page=${page}`);
  },
  deleteUser: (userId) => {
    return axios.delete(`/admin/users/${userId}`);
  },
  getUserDetails: (userId) => {
    return axios.get(`/admin/users/${userId}`);
  },
  activateUser: (userId) => {
    return axios.patch(`/admin/users/${userId}/activate`);
  },
  deactivateUser: (userId) => {
    return axios.patch(`/admin/users/${userId}/deactivate`);
  },
  verifyDocuments: (userId, verificationData) => {
    return axios.post(`/admin/verify-documents/${userId}`, verificationData);
  },
  getAllClients: (page = 1, limit = 0) => {
    return axios.get(`/admin/users?limit=${limit}&page=${page}`);
  },
};
